<template>

  <RidSddAllianz />
 
</template>

<script>
import RidSddAllianz from '../components/pratiche/RidSddAllianz.vue'

export default {
  components: {
    RidSddAllianz
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
